import { lazy, type ComponentType, type LazyExoticComponent } from "react";

/**
 * Widgets interactivos que una nota puede incluir.
 *
 * El cuerpo de las notas es HTML inyectado (viene de Markdown), asi que no
 * puede traer componentes. La nota deja un marcador
 * `<div class="post-widget" data-widget="nombre">...texto...</div>` y NewsPost
 * monta aca el componente de ese nombre. Cada widget se carga bajo demanda: su
 * codigo y su CSS no pesan en el resto de las notas ni en el primer render.
 */
export const NEWS_WIDGETS: Record<string, LazyExoticComponent<ComponentType>> = {
  "yacyreta-hydro": lazy(() => import("./YacyretaHydroSimulator")),
  "yacyreta-vision": lazy(() => import("./YacyretaVisionSimulator")),
};
